import is from './is'

export default function toLower(str) {
  if (!is.string(str)) {
    throw new Error('str must be a string')
  }
  return str.toLowerCase()
}
